import { customerService } from "@/api/customerService";
import { scenarioService } from "@/api/scenarioService";
import type { AgentGroup } from "@/resources/agentGroup";
import type {
  ScenarioDisplayNameItem,
  ScenarioWithId,
} from "@/resources/scenario";
import store from "@/store";

const loadedScenarios: { [key: string]: ScenarioWithId } = {};

export async function getScenarioById(
  scenarioId: string,
): Promise<ScenarioWithId | null> {
  if (loadedScenarios[scenarioId]) {
    return loadedScenarios[scenarioId];
  }

  const scenario = await scenarioService.getById(scenarioId);

  if (scenario) {
    loadedScenarios[scenarioId] = scenario;
  }

  return scenario;
}

export function getScenarioDisplayName(
  scenario: ScenarioWithId,
  agentGroups: AgentGroup[],
): ScenarioDisplayNameItem {
  const agentGroup = agentGroups.find(
    (group) => group.id === scenario.agentGroupId,
  );
  return {
    scenarioDisplayName: agentGroup
      ? `${scenario.name} (${agentGroup.name})`
      : scenario.name,
    scenarioName: scenario.name,
  };
}

export function getScenarioNameById(
  scenarioId: string | undefined,
  availableScenarios: ScenarioWithId[],
  availableAgentGroups: AgentGroup[],
): string {
  const scenario = availableScenarios.find(
    (scenario) =>
      scenario.scenarioIdLegacy === scenarioId || scenario.id === scenarioId,
  );
  if (!scenario) return "";
  return getScenarioDisplayName(scenario, availableAgentGroups)
    .scenarioDisplayName;
}

export async function fetchScenarios(): Promise<ScenarioWithId[]> {
  const customerId = store.getters.customerId;
  if (!customerId) {
    console.warn("[fetchScenarios] No customerId available");
    return [];
  }

  const customer = await customerService.getById(customerId);
  if (!customer) {
    console.warn(`Customer with ID ${customerId} not found`);
    return [];
  }

  return await scenarioService.list({
    id: customer.scenarioDocIds,
  });
}
